import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 16,
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "#667085",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Chart" }),
		/* @__PURE__ */ _jsx("path", { d: "M13.5 2a7 7 0 0 0-.5 0 1 1 0 0 0-1 1v8c0 .6.4 1 1 1h8c.5 0 1-.4 1-1v-.5A8.5 8.5 0 0 0 13.5 2Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M11 6a1 1 0 0 0-1-1 8.5 8.5 0 1 0 9 9 1 1 0 0 0-1-1h-7V6Z" })
	]
});
export default SvgChart;
